import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, y = 35, className = "", once = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines = [], className = "", lineClass = "", baseDelay = 0, stagger = 0.16 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className={`block overflow-hidden ${lineClass}`}>
          <motion.span
            className="block will-change-transform"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, ease: EASE, delay: baseDelay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Eyebrow({ children, className = "", light = false }) {
  return (
    <FadeUp y={16}>
      <span className={`inline-flex items-center gap-3 ${light ? "text-gold-light" : "text-gold"} ${className}`}>
        <span className={`h-px w-8 ${light ? "bg-gold-light/60" : "bg-gold/60"}`} />
        <span className="eyebrow">{children}</span>
      </span>
    </FadeUp>
  );
}
